import { Redirect } from 'react-router';

const SignOut = (): JSX.Element => {
    return <Redirect to='/' />;
};

export default SignOut;
